import styled from '@emotion/styled';
import { Popper } from '@mui/material';
import { theme } from 'theme';
import pxToEm from 'theme/pxToEm';

export const Dropdown = styled(Popper, {
  shouldForwardProp: (prop) => !['minWidth'].includes(String(prop)),
})`
  z-index: 5;
  background: ${theme.palette.common.white};
  box-shadow: 0px 4px 25px rgb(0 0 0 / 8%);
  margin-top: ${pxToEm(4)} !important;
  border-radius: ${pxToEm(8)};
  overflow: hidden;
  padding: 0.5em;
  min-width: ${({ minWidth }: { minWidth?: number }) => minWidth || '0'}px;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;

  & .MuiDivider-root {
    border-color: ${theme.palette.grey[50]};
  }
`;
